(() => {
  const script = document.querySelector('script[data-vp-visual-options]');
  const targets = 'select[data-promo-option], [data-promo-inks] select, select[data-display-option], select[data-led-option], [data-vp-brochure-order] select, select[data-vp-banner-finishing], select[data-pen-tip], select[data-pen-ink], select[data-pen-quantity], [data-legacy-pen] select';
  const entries = new Map();
  let serial = 0, scheduled = false;
  const svg = (paths, viewBox = '0 0 80 48') => {
    const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    icon.setAttribute('viewBox', viewBox);
    icon.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    icon.setAttribute('aria-hidden', 'true');
    for (const [name, attrs] of paths) {
      const node = document.createElementNS(icon.namespaceURI, name);
      Object.entries(attrs).forEach(([key, value]) => node.setAttribute(key, value));
      icon.append(node);
    }
    return icon;
  };
  const labelFor = select => select.getAttribute('aria-label') || [...(select.labels || [])].map(label => [...label.childNodes].filter(n => n.nodeType === 3).map(n => n.textContent).join(' ').trim()).find(Boolean) || select.name.replace(/^properties\[|^options\[|\]$/g, '') || 'Option';
  const dimensions = value => {
    const match = value.replaceAll('″', '"').match(/(\d+(?:\.\d+)?)\s*["′']?\s*[x×]\s*(\d+(?:\.\d+)?)/i);
    return match ? [Number(match[1]), Number(match[2])] : null;
  };
  function foldIcon(value, context) {
    const dim = dimensions(context.size);
    if (!dim) return null;
    const all = context.sizes.map(dimensions).filter(Boolean);
    const scale = 60 / Math.max(1, ...all.flat());
    const sheetWidth = Math.max(...dim), sheetHeight = Math.min(...dim);
    const width = sheetWidth * scale, height = sheetHeight * scale;
    const x = (80 - width) / 2, y = 44 - height, quarter = sheetWidth / 4;
    const tuck = 1 / 16, third = (sheetWidth + tuck) / 3;
    const folds = {
      'Flat / No Fold': {panels: [sheetWidth], angles: [0]},
      'Half-Fold': {panels: [sheetWidth / 2, sheetWidth / 2], angles: [-35, 35], order: [1]},
      'Tri-Fold': {panels: [third, third, third - tuck], angles: [0, 90, 180], order: [2, 1]},
      'Accordion Fold': {panels: [quarter, quarter, quarter, quarter], angles: [0, 135, 0, 135], order: [1, 2, 3]},
      'Gatefold': {panels: [quarter, 2 * quarter, quarter], angles: [-90, 0, 90], order: [1, 1]},
      'Roll Fold': {panels: [quarter + tuck, quarter + tuck, quarter + tuck - 3 / 32, quarter + tuck - 5 / 32], angles: [0, 75, 150, 225], order: [3, 2, 1]},
      'Reverse Double-Parallel Fold': {panels: [quarter - 1 / 32, quarter - 1 / 32, quarter + 1 / 32, quarter + 1 / 32], angles: [0, 105, 210, 105], order: [2, 1, 2]},
      'Double-Parallel Fold': {panels: [quarter + 1 / 32, quarter + 1 / 32, quarter - 1 / 32, quarter - 1 / 32], angles: [0, -105, 0, 105], order: [2, 1, 2]},
      'Double Gatefold': {panels: [quarter - tuck, quarter + tuck, quarter + tuck, quarter - tuck], angles: [-90, 0, -75, 15], order: [1, 2, 1]},
      'French Fold': {panels: [sheetWidth / 2, sheetWidth / 2], cross: true, order: [2]},
      'Z-Fold': {panels: [sheetWidth / 3, sheetWidth / 3, sheetWidth / 3], angles: [0, 135, 0], order: [1, 2]}
    };
    const fold = folds[value];
    if (!fold) return null;
    const paths = [];
    let offset = 0;
    fold.panels.forEach((panel, index) => {
      const panelWidth = panel * scale;
      paths.push(['rect', {x: x + offset, y, width: panelWidth, height, fill: 'currentColor', 'fill-opacity': index % 2 ? '.1' : '.035', stroke: 'none'}]);
      offset += panelWidth;
      if (index === fold.panels.length - 1) return;
      const turn = fold.angles ? fold.angles[index + 1] - fold.angles[index] : 90;
      paths.push(['path', {d: 'M' + (x + offset) + ' ' + y + 'v' + height, 'stroke-dasharray': '2.5 2', 'stroke-width': 1.2, 'data-vp-fold-crease': '', 'data-fold-axis': 'vertical', 'data-fold-order': fold.order[index], 'data-fold-direction': turn < 0 ? 'mountain' : 'valley'}]);
    });
    if (fold.cross) paths.push(['path', {d: 'M' + x + ' ' + (y + height / 2) + 'h' + width, 'stroke-dasharray': '2.5 2', 'stroke-width': 1.2, 'data-vp-fold-crease': '', 'data-fold-axis': 'horizontal', 'data-fold-order': 1}]);
    paths.push(['rect', {x, y, width, height, rx: .6, 'data-vp-fold-outline': ''}]);
    if (fold.cross) {
      const profileScale = Math.min(width / (sheetWidth / 2), 16 / (sheetHeight / 2));
      const pw = sheetWidth / 2 * profileScale, ph = sheetHeight / 2 * profileScale;
      for (let layer = 3; layer >= 0; layer--) paths.push(['rect', {x: (80 - pw) / 2 + layer * .65, y: 62 - ph / 2 - layer * .65, width: pw, height: ph, rx: .3, fill: layer ? '#fff' : '#eef0ff', 'stroke-width': .9, 'data-vp-fold-profile': ''}]);
    } else {
      const points = [[0, 0]];
      fold.panels.forEach((panel, index) => {
        const angle = fold.angles[index] * Math.PI / 180, last = points.at(-1);
        points.push([last[0] + panel * Math.cos(angle), last[1] + panel * Math.sin(angle)]);
      });
      const xs = points.map(p => p[0]), ys = points.map(p => p[1]);
      const minX = Math.min(...xs), minY = Math.min(...ys), spanX = Math.max(...xs) - minX, spanY = Math.max(...ys) - minY;
      const profileScale = Math.min(width / Math.max(.01, spanX), 16 / Math.max(.01, spanY));
      const left = (80 - spanX * profileScale) / 2, top = 62 - spanY * profileScale / 2;
      const d = points.map(([px, py], index) => (index ? 'L' : 'M') + (left + (px - minX) * profileScale).toFixed(3) + ' ' + (top + (py - minY) * profileScale).toFixed(3)).join('');
      paths.push(['path', {d, 'stroke-width': 1.7, 'data-vp-fold-profile': ''}]);
    }
    const icon = svg(paths, '0 0 80 80');
    icon.classList.add('vp-choice-fold-icon');
    Object.assign(icon.dataset, {sheetWidth, sheetHeight, foldType: value, panelCount: fold.cross ? 4 : fold.panels.length});
    return icon;
  }
  function iconFor(label, value, values, sheetSize = false, foldContext = null) {
    if (foldContext) { const icon = foldIcon(value, foldContext); if (icon) return icon; }
    const type = label.toLowerCase();
    if (/size|dimension|format/.test(type)) {
      const dim = dimensions(value), all = values.map(dimensions).filter(Boolean);
      const maxW = Math.max(1, ...all.map(x => x[0])), maxH = Math.max(1, ...all.map(x => x[1]));
      if (sheetSize && dim) {
        const scale = Math.min(60 / maxW, 60 / maxH);
        const width = Math.max(...dim) * scale, height = Math.min(...dim) * scale;
        const x = (80 - width) / 2, y = 65 - height;
        const icon = svg([
          ['rect', {x, y, width, height, rx: .8, 'data-vp-sheet-outline': ''}],
          ['path', {d: `M${x} 73h${width}M${x} 70v6M${x + width} 70v6`}]
        ], '0 0 80 80');
        icon.classList.add('vp-choice-paper-icon');
        icon.dataset.sheetWidth = dim[0];
        icon.dataset.sheetHeight = dim[1];
        return icon;
      }
      const width = dim ? Math.max(18, dim[0] / maxW * 56) : 48;
      const height = dim ? Math.max(8, dim[1] / maxH * 24) : 26;
      const x = (80 - width) / 2, y = (42 - height) / 2;
      return svg([['rect', {x, y, width, height, rx: 2}], ['path', {d: `M${x} 42h${width}m-${width} -3v6m${width} -6v6`}]]);
    }
    if (/quantity|pack|number/.test(type)) return svg([['rect', {x: 17, y: 8, width: 38, height: 27, rx: 2}], ['path', {d: 'M25 36v5h38V15h-7M28 16h16M28 22h16M28 28h10'}]]);
    if (/sides|graphic|printing|decoration|imprint/.test(type)) return svg([['rect', {x: 15, y: 9, width: 37, height: 27, rx: 2}], ['path', {d: /double|2-color|two/i.test(value) ? 'M55 14h10v26H28v-3M25 17h17M25 23h17M25 29h10' : 'M25 17h17M25 23h17M25 29h10'}]]);
    if (/fold/.test(type)) return svg([['path', {d: 'M12 12l18-5 20 5 18-5v28l-18 5-20-5-18 5zM30 7v28M50 12v28'}]]);
    return svg([['rect', {x: 17, y: 8, width: 46, height: 32, rx: 3}], ['path', {d: 'm29 24 7 7 15-15'}]]);
  }
  function hideNative(select) {
    const label = select.closest('label');
    (label || select).classList.add('vp-choice-native');
    select.setAttribute('aria-hidden', 'true');
    select.tabIndex = -1;
    if (!label) for (const item of select.labels || []) item.classList.add('vp-choice-native');
  }
  function hasStockPicker(select) {
    if (!select.matches('[data-promo-option]')) return false;
    const root = select.closest('[data-promo-root]');
    const index = [...root.querySelectorAll('[data-promo-option]')].indexOf(select);
    return !!root.querySelector(`[data-vp-stock-colors][data-option-index="${index}"]`);
  }
  function enhance(select) {
    if (!select.options.length || select.closest('[hidden]') || select.closest('.vp-promo__field[hidden]')) return;
    if (!entries.has(select) && !select.getClientRects().length) return;
    if (hasStockPicker(select)) { hideNative(select); return; }
    const label = labelFor(select), options = [...select.options].filter(o => o.value);
    if (!options.length) return;
    const sheetSelect = select.matches('[data-vp-brochure-order] [data-vp-fold]') ? select.closest('[data-vp-brochure-order]').querySelector('[data-vp-size]') : null;
    const foldContext = sheetSelect ? {size: sheetSelect.value, sizes: [...sheetSelect.options].map(o => o.value).filter(Boolean)} : null;
    const signature = JSON.stringify([options.map(o => [o.value, o.textContent, o.disabled, o.dataset.vpColor]), foldContext?.size]);
    let entry = entries.get(select);
    if (entry && entry.signature === signature && entry.field.isConnected) { sync(select, entry); return; }
    entry?.field.remove();
    const field = document.createElement('fieldset');
    field.className = 'vp-choice-field';
    const legend = document.createElement('legend'); legend.textContent = label;
    if (foldContext) {
      field.classList.add('vp-choice-field--folds');
      const size = document.createElement('small'); size.textContent = foldContext.size.replaceAll(' x ', ' × ');
      legend.append(size);
    }
    const group = document.createElement('div'); group.className = 'vp-choice-grid';
    group.setAttribute('role', 'radiogroup'); group.setAttribute('aria-label', label);
    group.setAttribute('aria-required', String(select.required));
    const help = document.createElement('p'); help.className = 'vp-choice-error'; help.hidden = true;
    help.id = `vp-choice-error-${++serial}`;
    help.textContent = (script?.dataset.choose || 'Choose __OPTION__.').replace('__OPTION__', label.toLowerCase());
    group.setAttribute('aria-describedby', help.id);
    const sheetSize = select.matches('[data-vp-brochure-order] [data-vp-size]');
    if (sheetSize) field.classList.add('vp-choice-field--sheet-size');
    const colored = /colou?r|writing ink/i.test(label) || select.hasAttribute('data-promo-color') || select.hasAttribute('data-pen-ink');
    if (colored) field.classList.add('vp-choice-field--colors');
    for (const option of options) {
      const button = document.createElement('button'); button.type = 'button';
      button.className = 'vp-choice'; button.setAttribute('role', 'radio');
      button.setAttribute('aria-label', option.textContent); button.dataset.value = option.value;
      if (colored && option.dataset.vpColor) {
        const sample = document.createElement('span'); sample.className = 'vp-choice-color';
        sample.style.background = option.dataset.vpColor; sample.setAttribute('aria-hidden', 'true'); button.append(sample);
      } else button.append(iconFor(label, option.textContent, options.map(o => o.textContent), sheetSize, foldContext));
      const text = document.createElement('span'); text.className = 'vp-choice-text';
      const stamp = option.textContent.match(/^(Small|Medium|Large)\s*\((.+)\)$/i);
      if (stamp) { const title = document.createElement('strong'); title.textContent = stamp[1]; const detail = document.createElement('small'); detail.textContent = stamp[2].replaceAll(' x ', ' × '); text.append(title, detail); }
      else text.textContent = option.textContent;
      button.append(text);
      button.addEventListener('click', () => {
        if (button.disabled) return;
        select.value = option.value;
        select.dispatchEvent(new Event('input', {bubbles: true}));
        select.dispatchEvent(new Event('change', {bubbles: true}));
        scan();
      });
      group.append(button);
    }
    group.addEventListener('keydown', event => {
      if (!['ArrowRight','ArrowLeft','ArrowDown','ArrowUp','Home','End'].includes(event.key)) return;
      event.preventDefault();
      const enabled = [...group.querySelectorAll('button')].filter(b => !b.disabled);
      const index = enabled.indexOf(document.activeElement);
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? enabled.length - 1 : (index + (/Right|Down/.test(event.key) ? 1 : -1) + enabled.length) % enabled.length;
      enabled[next]?.focus(); enabled[next]?.click();
    });
    field.append(legend, group, help);
    const host = select.closest('label') || select;
    host.before(field); hideNative(select);
    entry = {field, group, help, signature, optionMap:new Map(options.map(o=>[o.value,o]))}; entries.set(select, entry);
    if (!select.dataset.vpChoiceBound) {
      select.dataset.vpChoiceBound = 'true';
      select.addEventListener('invalid', event => {
        const current = entries.get(select); if (!current) return;
        event.preventDefault(); current.help.hidden = false;
        current.group.setAttribute('aria-invalid', 'true'); current.group.querySelector('button:not(:disabled)')?.focus();
      });
    }
    sync(select, entry);
  }
  function sync(select, entry) {
    const buttons = [...entry.group.querySelectorAll('button')];
    const selected = buttons.find(b => b.dataset.value === select.value);
    const firstEnabled=buttons.find(b=>!select.disabled&&!entry.optionMap.get(b.dataset.value)?.disabled);
    for (const button of buttons) {
      const option = entry.optionMap.get(button.dataset.value);
      button.disabled = select.disabled || !!option?.disabled;
      button.setAttribute('aria-checked', String(button === selected));
      button.tabIndex = !button.disabled && (button === selected || (!selected && button === firstEnabled)) ? 0 : -1;
    }
    if (select.value) { entry.help.hidden = true; entry.group.removeAttribute('aria-invalid'); }
  }
  function scan() {
    scheduled = false;
    for (const [select] of entries) if (!select.isConnected) entries.delete(select);
    document.querySelectorAll(targets).forEach(enhance);
  }
  const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(scan); } };
  document.addEventListener('change', schedule);
  document.addEventListener('variant:change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(records => { if (records.some(r => [...r.addedNodes, ...r.removedNodes].some(n => n.nodeType === 1 && (n.matches?.('select,option,[data-promo-inks]') || n.querySelector?.(targets))))) schedule(); }).observe(document.body, {childList:true,subtree:true});
  scan();
})();
